import React from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { Row, Col } from '../Grid';
import { Checkbox } from '../Checkbox';

const NotificationFilters: React.FC<{
  filtersCheckboxProps: (
    filter: 'coop' | 'agent' | 'announcement' | 'transfer',
  ) => {
    checked: boolean;
    onChange: ({ target: { checked } }: CheckboxChangeEvent) => void;
  };
}> = ({ filtersCheckboxProps }) => (
    <Row>
      <Col>
        <Checkbox {...filtersCheckboxProps('coop')}>
          Requested Showings
        </Checkbox>
      </Col>
      <Col>
        <Checkbox {...filtersCheckboxProps('announcement')}>
          Announcements
        </Checkbox>
      </Col>
      <Col>
        <Checkbox {...filtersCheckboxProps('agent')}>My Listings</Checkbox>
      </Col>
      <Col>
        <Checkbox {...filtersCheckboxProps('transfer')}>Transfers</Checkbox>
      </Col>
    </Row>
  );

export default NotificationFilters;
